import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const services = [
  {
    id: 1,
    title: "ElectroPlating",
    text: "Our gold, silver, chrome and other plating services add a touch of elegance and durability to a wide variety of products. Whether it's jewelry, luxury accessories, or industrial components, our team meticulously applies these precious metal coatings to achieve a brilliant finish that stands the test of time.",
    image: "./assets/electroplating.jpeg",
  },
  {
    id: 2,
    title: "Anodizing",
    text: "For aluminum and other non-ferrous metals, our anodizing process offers excellent protection and color options. Anodized components are widely used in industries such as aerospace, electronics, and architecture, where durability and aesthetic appeal are crucial.",
    image: "./assets/anodizing.jpg",
  },
  {
    id: 3,
    title: "Custom Finishes",
    text: "We understand that some projects require unique and distinctive finishes. Our team is equipped to work closely with you to develop custom solutions that match your specific requirements and design preferences. Let us turn your vision into reality!",
    image: "./assets/Quality.jpeg",
  },
  {
    id: 4,
    title: "Quality Assurance",
    text: "Quality is our top priority at ElectroplatingLB. With our strict quality control measures, state-of-the-art equipment, and skilled technicians, we ensure that each item leaving our facility meets the highest standards of excellence.",
    image: "./assets/qualityassurance.jpeg",
  },
];

const ServicesCards = () => {
  return (
    <section className="services-section">
      <Container>
        <div className="section-header">
          <span className="section-label">What We Offer</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Our commitment to excellence, advanced technology, and skilled
            craftsmanship ensure that we deliver high-quality results for every
            project.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <Row
              key={service.id}
              className={`service-row ${index % 2 === 1 ? "flex-row-reverse" : ""}`}
            >
              <Col xs={12} lg={6} className="service-image-col">
                <div className="service-image-wrapper">
                  <span className="service-number">0{service.id}</span>
                  <Card.Img
                    src={service.image}
                    className="service-image"
                    loading="lazy"
                    alt={service.title}
                  />
                  <div className="service-image-overlay"></div>
                </div>
              </Col>
              <Col xs={12} lg={6} className="service-content-col">
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-text">{service.text}</p>
                  <Button to="/contact" variant="outline" size="sm">
                    Learn More <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                  </Button>
                </div>
              </Col>
            </Row>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ServicesCards;
